import { NavigationTab } from 'shared/model';
import { GROUPS } from 'shared/consts/routes/group';
import {
  MANUAL_COMMANDS,
  RESERVES,
  SESSION_LOG,
} from 'shared/consts/routes/common';

import { AddChargePointButtonLink } from 'entities/charge-point';

import { AddGroupButton } from 'features/group/add-group-button';
import { OpenManualCommandButton } from 'features/manual-command/ui/open-manual-command-modal-button';

export const CHARGE_POINTS_TABS: Array<NavigationTab> = [
  {
    key: 'charge-points',
    path: '',
    label: 'Мониторинг',
    buttons: [
      {
        element: <AddChargePointButtonLink />,
        controller: 'ChargePoint',
        right: 'Write',
      },
    ],
  },
  {
    key: GROUPS,
    path: GROUPS,
    label: 'Список групп',
    controller: 'Group',
    right: 'Write',
    buttons: [{ element: <AddGroupButton /> }],
  },
  {
    key: SESSION_LOG,
    path: SESSION_LOG,
    label: 'Журнал сессий',
    controller: 'PrivateMethods',
    right: 'Read', //
    hasLoader: true,
  },
  {
    key: RESERVES,
    path: RESERVES,
    label: 'Журнал брони',
    controller: 'PrivateMethods',
    right: 'Read', //
  },
  {
    key: MANUAL_COMMANDS,
    path: MANUAL_COMMANDS,
    label: 'Управление',
    controller: 'PrivateMethods',
    right: 'Read', //
    buttons: [
      {
        element: <OpenManualCommandButton />,
        controller: 'PrivateMethods',
        right: 'Execute',
      },
    ],
  },
];
